import { useState } from 'react';
import { API_URL } from '../../config';
import SiteLayout from '../../layouts/SiteLayout';
import Header from '../../components/Header/Header';
import Box from '../../components/Common/Box';

const ContactsScreen: React.FC = () => {
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSent(false);

    try {
      const response = await fetch(`${API_URL}/v1/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          sender_email: email,
          subject,
          content: message,
        }),
      });

      if (response.ok) {
        setSent(true);
        setSubject('');
        setMessage('');
        setEmail('');
      } else {
        setError("Erreur lors de l'envoi du message.");
      }
    } catch (error) {
      console.error('Error sending message:', error);
      setError('Erreur de connexion.');
    }
  };

  return (
    <SiteLayout>
      <Header icon='contact_mail' title='Contacts' />
      <Box>
        <div className='box-title box-vertical-padding box-horizontal-padding'>
          <p>Contacter l'administrateur</p>
        </div>
        <div className='box-content box-horizontal-padding' style={{ padding: '20px' }}>
          {sent && (
            <div
              style={{
                padding: '10px',
                backgroundColor: '#e8f5e9',
                color: '#2e7d32',
                marginBottom: '20px',
                borderRadius: '4px',
              }}
            >
              Message envoyé avec succès !
            </div>
          )}
          {error && (
            <div
              style={{
                padding: '10px',
                backgroundColor: '#fee2e2',
                color: '#b91c1c',
                marginBottom: '20px',
                borderRadius: '4px',
              }}
            >
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                Votre Email
              </label>
              <input
                type='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                Sujet
              </label>
              <input
                type='text'
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                Message
              </label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
                rows={5}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                }}
              />
            </div>
            <button type='submit' className='button button-purple'>
              Envoyer le message
            </button>
          </form>
        </div>
      </Box>
    </SiteLayout>
  );
};

export default ContactsScreen;
